import { render, staticRenderFns } from "./AppointmentsReport.vue?vue&type=template&id=718ade60&"
import script from "./AppointmentsReport.vue?vue&type=script&lang=js&"
export * from "./AppointmentsReport.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsReport.vue?vue&type=style&index=0&id=718ade60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports